import { render, staticRenderFns } from "./general-inventory-report-detail.vue?vue&type=template&id=df5a876a&"
import script from "./general-inventory-report-detail.vue?vue&type=script&lang=ts&"
export * from "./general-inventory-report-detail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports